import { z } from 'zod'

/**
 * The `$formId` segment. It is parsed once, at the route, so every page under
 * it reads a positive whole number: a hand-typed `/feedback-forms/abc` fails
 * here instead of reaching the API as `NaN`.
 */
export const feedbackFormParamsSchema = z.object({
  formId: z.coerce.number().int().positive(),
})

export type FeedbackFormParams = z.infer<typeof feedbackFormParamsSchema>
